import { createFileRoute } from '@tanstack/react-router'
import { LocationsTab, parseFocus } from '@/features/settings'

/** C-07 Locations; `focus` (a row id from a C-05 arrow) scrolls to and flashes that row (Frontend §6.1). */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/booking/locations')({
  validateSearch: parseFocus,
  component: function LocationsRoute() {
    const { focus } = Route.useSearch()
    return <LocationsTab focus={focus} />
  },
})
